import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { queriesBatches } from "@query";

import { ErrorAlert } from "@components/ErrorAlert";

type Props = {
  batchId: string;
  batchName: string;
} & WSModalCustomProps<boolean>;

const ModalConfirmPayableImportBatchDelete: React.FC<Props> = props => {
  const [deleteBatch, deleteBatchMeta] =
    queriesBatches.deleteBatch.useMutation();

  const onDelete = async () => {
    await deleteBatch(
      { batchId: props.batchId },
      { onSuccess: () => props.onClose(true) }
    );
  };

  return (
    <WSModal
      title={`Delete ${props.batchName}?`}
      size="S"
      onClose={() => props.onClose(false)}
      actions={{
        buttons: [
          {
            kind: "Secondary",
            label: "Cancel",
            onClick: () => props.onClose(false)
          },
          {
            kind: "Primary",
            destructive: true,
            label: "Delete batch",
            loading: deleteBatchMeta.isLoading,
            onClick: onDelete
          }
        ]
      }}
    >
      <WSList gap="M">
        <WSText>
          This deletes the batch and everything uploaded into it. Payables that
          were already imported are not affected. This cannot be undone.
        </WSText>
        <ErrorAlert context="BulkBatchUpdate" error={deleteBatchMeta.error} />
      </WSList>
    </WSModal>
  );
};

export const useModalConfirmPayableImportBatchDelete = () =>
  useWSModalCustom(ModalConfirmPayableImportBatchDelete);
